import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { myMSALObj, handleRedirectPromise } from "@/authConfig";
import { controlAcceso } from '@/utils/acceso';
import { withRetry } from '@/utils/NetworkRetry';

Vue.use(VueRouter);

async function guardMyroute(to, from, next) {
  // Esperamos a que MSAL procese cualquier redirección pendiente
  await handleRedirectPromise;

  let account = myMSALObj.getActiveAccount();

  if (!account) {
    const accounts = myMSALObj.getAllAccounts();
    if (accounts.length > 0) {
      account = accounts[0];
      myMSALObj.setActiveAccount(account);
    }
  }

  // Si ya tenemos cuenta y estamos en /Login, vamos a Home
  if (account && to.path.toLowerCase() === "/login") {
    return next("/");
  }

  try {
    const tokenResponse = await withRetry(() =>
      myMSALObj.acquireTokenSilent({
        scopes: ["user.read"],
      })
    );

    Vue.prototype.$roles = tokenResponse.account?.idTokenClaims?.roles || [];
    Vue.prototype.$user = tokenResponse.account?.username;
    account = tokenResponse.account;

    console.log("Logged User:", account?.username);
    await controlAcceso.obtenerInfo();
    return next();
  } catch (error) {
    console.warn("Silent token acquisition failed in router guard, attempting ssoSilent...", error);

    try {
      const ssoResponse = await withRetry(() =>
        myMSALObj.ssoSilent({
          scopes: ["user.read"],
          loginHint: account?.username
        })
      );

      Vue.prototype.$roles = ssoResponse.account?.idTokenClaims?.roles || [];
      Vue.prototype.$user = ssoResponse.account?.username;
      myMSALObj.setActiveAccount(ssoResponse.account);

      await controlAcceso.obtenerInfo();
      return next();
    } catch (ssoError) {
      console.error("SSO Silent failed, redirecting to login", ssoError);
      if (to.path.toLowerCase() === "/login") return next();
      return next("/login");
    }
  }
}

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    components: {
      default: () => import("../views/Home.vue"),
      navigation: () => import("@/components/generales/Navigation.vue"),
    },
    beforeEnter: guardMyroute,
  },
  {
    path: "/Login",
    name: "Login",
    components: {
      default: () => import("../views/Login.vue"),
    },
  },
  {
    path: "/UnidadesNegocio",
    name: "UnidadesNegocio",
    components: {
      default: () => import("../views/UnidadesNegocio.vue"),
      navigation: () => import("@/components/generales/Navigation.vue"),
    },
    beforeEnter: guardMyroute,
  },
  {
    path: "/ReferenciasHijas",
    name: "ReferenciasHijas",
    components: {
      default: () => import("../views/ReferenciasHijas.vue"),
      navigation: () => import("@/components/generales/Navigation.vue"),
    },
    beforeEnter: guardMyroute,
  },
  {
    path: "/Productos",
    name: "Productos",
    components: {
      default: () => import("../views/Productos.vue"),
      navigation: () => import("@/components/generales/Navigation.vue"),
    },
    beforeEnter: guardMyroute,
  },
  {
    path: "/Clientes",
    name: "Clientes",
    components: {
      default: () => import("../views/Clientes.vue"),
      navigation: () => import("@/components/generales/Navigation.vue"),
    },
    beforeEnter: guardMyroute,
  },
  {
    path: "/ProductosConfigurables",
    name: "Productos Configurables",
    components: {
      default: () => import("../views/ProductosConfigurables.vue"),
      navigation: () => import("@/components/generales/Navigation.vue"),
    },
    beforeEnter: guardMyroute,
  },
  {
    path: "/Presupuestos",
    name: "Presupuestos",
    components: {
      default: () => import("../views/Presupuestos.vue"),
      navigation: () => import("@/components/generales/Navigation.vue"),
    },
    beforeEnter: guardMyroute,
  },
  {
    path: "/formulario-presupuesto-pdf/:presupuestoID",
    name: "FormularioPresupuestoPDF",
    components: {
      default: () => import("../views/FormularioPresupuestoPDF.vue"),
      navigation: () => import("@/components/generales/Navigation.vue"),
    },
    props: { default: true },
    beforeEnter: guardMyroute,
  },
  {
    path: "*",
    component: () => import("../views/404Page.vue"),
    meta: { layout: "none" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
